import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

function ProjectBreadcrumbs({ items, className = '' }) {
  const rootClassName = ['project-breadcrumb', className].filter(Boolean).join(' ');

  return (
    <nav className={rootClassName} aria-label="Breadcrumb">
      <ol className="project-breadcrumb-list">
        {items.map((item, index) => {
          const isLastItem = index === items.length - 1;

          return (
            <li className="project-breadcrumb-item" key={`${item.label}-${item.to || index}`}>
              {item.to && !isLastItem ? (
                <Link className="project-breadcrumb-link" to={item.to} state={item.state}>
                  {item.label}
                </Link>
              ) : (
                <span className="project-breadcrumb-current" aria-current={isLastItem ? 'page' : undefined}>
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

ProjectBreadcrumbs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      to: PropTypes.string,
      state: PropTypes.shape({})
    })
  ).isRequired,
  className: PropTypes.string
};

export default ProjectBreadcrumbs;